module.exports = __webpack_public_path__ + "static/solution4-32cd039f59d9a707bc97582d47c5d76f.png";